package com.karyadina.service

import com.karyadina.model.LockedFeature
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

/**
 * Stub implementation of SubscriptionService - used when iap module not available
 * All features unlocked by default
 */
class StubSubscriptionService : SubscriptionService {
    private val _purchases = MutableStateFlow<List<Any>>(emptyList())
    override val purchases: StateFlow<Any> = _purchases.asStateFlow()

    override fun isFeatureUnlocked(feature: LockedFeature): Boolean {
        return true  // All features unlocked in stub
    }

    override fun getActivePackages(): List<String> {
        return emptyList()
    }

    override suspend fun forceRefreshPurchases() {
        // Stub - no-op
    }
}
